import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-minus-svg',
  standalone: true,
  imports: [],
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666504 9.3334H19.3332V10.6667H0.666504V9.3334Z"
      fill="#1C1D1F"
    />
  </svg> `,
  styles: ``,
})
export class MinusSvgComponent {
  @Input() width?: string = '20px';
  @Input() height?: string = '20px';
}
